import { render } from "./SubscriptionDetails.vue?vue&type=template&id=2c85bae6&scoped=true&ts=true"
import script from "./SubscriptionDetails.vue?vue&type=script&lang=ts"
export * from "./SubscriptionDetails.vue?vue&type=script&lang=ts"

import "./SubscriptionDetails.vue?vue&type=style&index=0&id=2c85bae6&scoped=true&lang=scss"
import "./SubscriptionDetails.vue?vue&type=style&index=1&id=2c85bae6&lang=css"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c85bae6"]])

export default __exports__